{
  "REPORT": {
    "HEADER": "Диалоги",
    "LOADING_CHART": "Загрузка данных графика...",
    "NO_ENOUGH_DATA": "Недостаточно данных для создания отчета, пожалуйста, повторите попытку позже.",
    "DOWNLOAD_AGENT_REPORTS": "Сказать отчёт по агентам",
    "DATA_FETCHING_FAILED": "Не удалось загрузить данные. Пожалуйста, попробуйте позже.",
    "SUMMARY_FETCHING_FAILED": "Не удалось загрузить сводку. Пожалуйста, попробуйте позже.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Диалоги",
        "DESC": "( Всего )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Входящие сообщения",
        "DESC": "( Всего )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Исходящие сообщения",
        "DESC": "( Всего )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Время первого ответа",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов для расчета:",
        "TOOLTIP_TEXT": "Время первого ответа — {metricValue} (на основе {conversationCount} сообщений)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Время Завершения",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов для расчета:",
        "TOOLTIP_TEXT": "Время на решение {metricValue} (основано на {conversationCount} разговорах)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Количество завершенных",
        "DESC": "( Всего )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Количество завершенных",
        "DESC": "( Всего )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Количество передач",
        "DESC": "( Всего )"
      },
      "REPLY_TIME": {
        "NAME": "Время ожидания клиента",
        "TOOLTIP_TEXT": "Время ожидания {metricValue} (на основе {conversationCount} ответов)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Сегодня",
      "YESTERDAY": "Вчера",
      "LAST_7_DAYS": "Последние 7 дней",
      "LAST_30_DAYS": "Последние 30 дней",
      "THIS_MONTH": "Этот месяц",
      "LAST_MONTH": "Прошлый месяц",
      "LAST_3_MONTHS": "Последние 3 месяца",
      "LAST_6_MONTHS": "Последние 6 месяцев",
      "LAST_YEAR": "За прошлый год",
      "CUSTOM_DATE_RANGE": "Настраиваемый диапазон даты"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Применить",
      "PLACEHOLDER": "Выберите диапазон дат"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Группировать по",
    "DURATION_FILTER_LABEL": "Продолжительность",
    "GROUPING_OPTIONS": {
      "DAY": "День",
      "WEEK": "Неделя",
      "MONTH": "Месяц",
      "YEAR": "Год"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      },
      {
        "id": 2,
        "groupBy": "Неделя"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      },
      {
        "id": 2,
        "groupBy": "Неделя"
      },
      {
        "id": 3,
        "groupBy": "Месяц"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "День"
      },
      {
        "id": 2,
        "groupBy": "Неделя"
      },
      {
        "id": 3,
        "groupBy": "Месяц"
      }
    ],
    "BUSINESS_HOURS": "Время работы",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Очистить фильтр",
      "EMPTY_LIST": "Результаты не найдены"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Диалоги: {count}",
      "RESULT_COUNT_MESSAGE": "Сообщения: {count}",
      "EMPTY": "Для этого столбца записи не найдены.",
      "ERROR": "Не удалось загрузить записи. Повторите попытку.",
      "LOAD_MORE": "Загрузить ещё",
      "PREVIOUS_BUCKET": "Предыдущий столбец",
      "NEXT_BUCKET": "Следующий столбец",
      "UNKNOWN_CONTACT": "Неизвестный контакт",
      "UNKNOWN_INBOX": "Неизвестный канал",
      "UNASSIGNED_AGENT": "Не назначен",
      "NO_MESSAGE_CONTENT": "Нет содержимого сообщения",
      "MESSAGE_CREATED_AT": "Сообщение создано {time}",
      "EVENT_OCCURRED_AT": "Событие произошло {time}",
      "INCOMING_MESSAGE": "Входящее сообщение",
      "OUTGOING_MESSAGE": "Исходящее сообщение",
      "VIEW_ALL": "Показать в диалогах",
      "VIEW_ALL_LIMIT": "В списке диалогов открываются только столбцы, в которых не более {limit} диалогов.",
      "HIDDEN_COUNT": "Не показаны, так как вы не участник их канала: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Показаны {start} - {end} из {total} результатов",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Обзор агентов",
    "DESCRIPTION": "Легко отслеживайте эффективность работы агентов с помощью ключевых метрик, таких как количество бесед, время ответа, время решения проблем и количество решённых случаев. Нажмите на имя агента, чтобы узнать подробности.",
    "LOADING_CHART": "Загрузка данных графика...",
    "NO_ENOUGH_DATA": "Недостаточно данных для создания отчета, пожалуйста, повторите попытку позже.",
    "DOWNLOAD_AGENT_REPORTS": "Сказать отчёт по агентам",
    "FILTER_DROPDOWN_LABEL": "Выбрать Агента",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Диалоги",
        "DESC": "( Всего )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Входящие сообщения",
        "DESC": "( Всего )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Исходящие сообщения",
        "DESC": "( Всего )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Время первого ответа",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время первого ответа — {metricValue} (на основе {conversationCount} сообщений)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Время Завершения",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время на решение {metricValue} (основано на {conversationCount} разговорах)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Количество завершенных",
        "DESC": "( Всего )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Последние 7 дней"
      },
      {
        "id": 1,
        "name": "Последние 30 дней"
      },
      {
        "id": 2,
        "name": "Последние 3 месяца"
      },
      {
        "id": 3,
        "name": "Последние 6 месяцев"
      },
      {
        "id": 4,
        "name": "За прошлый год"
      },
      {
        "id": 5,
        "name": "Настраиваемый диапазон даты"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Применить",
      "PLACEHOLDER": "Выберите диапазон дат"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Обзор меток",
    "DESCRIPTION": "Отслеживайте эффективность меток по ключевым показателям: разговоры, время ответа, время решения и решённые обращения.",
    "LOADING_CHART": "Загрузка данных графика...",
    "NO_ENOUGH_DATA": "Недостаточно данных для создания отчета, пожалуйста, повторите попытку позже.",
    "DOWNLOAD_LABEL_REPORTS": "Скачать отчет по меткам",
    "FILTER_DROPDOWN_LABEL": "Выбрать метку",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Диалоги",
        "DESC": "( Всего )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Входящие сообщения",
        "DESC": "( Всего )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Исходящие сообщения",
        "DESC": "( Всего )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Время первого ответа",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время первого ответа — {metricValue} (на основе {conversationCount} сообщений)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Время Завершения",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время на решение {metricValue} (основано на {conversationCount} разговорах)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Количество завершенных",
        "DESC": "( Всего )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Последние 7 дней"
      },
      {
        "id": 1,
        "name": "Последние 30 дней"
      },
      {
        "id": 2,
        "name": "Последние 3 месяца"
      },
      {
        "id": 3,
        "name": "Последние 6 месяцев"
      },
      {
        "id": 4,
        "name": "За прошлый год"
      },
      {
        "id": 5,
        "name": "Настраиваемый диапазон даты"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Применить",
      "PLACEHOLDER": "Выберите диапазон дат"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Обзор входящих",
    "DESCRIPTION": "Быстро просматривайте эффективность источника входящих с основными метриками — количеством бесед, временем ответа, временем решения проблем и количеством решённых случаев — всё в одном месте. Нажмите на имя источника для получения подробной информации.",
    "LOADING_CHART": "Загрузка данных графика...",
    "NO_ENOUGH_DATA": "Недостаточно данных для создания отчета, пожалуйста, повторите попытку позже.",
    "DOWNLOAD_INBOX_REPORTS": "Скачать отчет по входящим",
    "FILTER_DROPDOWN_LABEL": "Выбрать \"Входящий\" канал",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Диалоги",
        "DESC": "( Всего )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Входящие сообщения",
        "DESC": "( Всего )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Исходящие сообщения",
        "DESC": "( Всего )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Время первого ответа",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время первого ответа — {metricValue} (на основе {conversationCount} сообщений)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Время Завершения",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время на решение {metricValue} (основано на {conversationCount} разговорах)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Количество завершенных",
        "DESC": "( Всего )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Последние 7 дней"
      },
      {
        "id": 1,
        "name": "Последние 30 дней"
      },
      {
        "id": 2,
        "name": "Последние 3 месяца"
      },
      {
        "id": 3,
        "name": "Последние 6 месяцев"
      },
      {
        "id": 4,
        "name": "За прошлый год"
      },
      {
        "id": 5,
        "name": "Настраиваемый диапазон даты"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Применить",
      "PLACEHOLDER": "Выберите диапазон дат"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Обзор команды",
    "DESCRIPTION": "Получите обзор работы вашей команды с основными метриками, такими как количество бесед, время ответа, время решения проблем и количество решённых случаев. Нажмите на имя команды для подробностей.",
    "LOADING_CHART": "Загрузка данных графика...",
    "NO_ENOUGH_DATA": "Недостаточно данных для создания отчета, пожалуйста, повторите попытку позже.",
    "DOWNLOAD_TEAM_REPORTS": "Скачать отчет по команде",
    "FILTER_DROPDOWN_LABEL": "Выберите команду",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Диалоги",
        "DESC": "( Всего )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Входящие сообщения",
        "DESC": "( Всего )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Исходящие сообщения",
        "DESC": "( Всего )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Время первого ответа",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время первого ответа — {metricValue} (на основе {conversationCount} сообщений)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Время Завершения",
        "DESC": "(Среднее)",
        "INFO_TEXT": "Общее количество диалогов, используемых для вычисления:",
        "TOOLTIP_TEXT": "Время на решение {metricValue} (основано на {conversationCount} разговорах)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Количество завершенных",
        "DESC": "( Всего )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Последние 7 дней"
      },
      {
        "id": 1,
        "name": "Последние 30 дней"
      },
      {
        "id": 2,
        "name": "Последние 3 месяца"
      },
      {
        "id": 3,
        "name": "Последние 6 месяцев"
      },
      {
        "id": 4,
        "name": "За прошлый год"
      },
      {
        "id": 5,
        "name": "Настраиваемый диапазон даты"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Применить",
      "PLACEHOLDER": "Выберите диапазон дат"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "Отчёты CSAT",
    "NO_RECORDS": "Нет ответов на опрос CSAT.",
    "DOWNLOAD": "Скачать отчёты CSAT",
    "DOWNLOAD_FAILED": "Не удалось загрузить CSAT отчёты",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Выберите Операторов"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Контакт",
        "AGENT_NAME": "Назначенный сотрудник",
        "RATING": "Оценка",
        "FEEDBACK_TEXT": "Комментарий отзыва"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Всего ответов",
        "TOOLTIP": "Общее количество собранных ответов"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Оценка удовлетворенности",
        "TOOLTIP": "Общее количество положительных ответов / Общее количество ответов * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Доля откликов",
        "TOOLTIP": "Общее количество ответов / Общее количество отправленных сообщений CSAT опросов * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Отчеты о боте",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Количество диалогов",
        "TOOLTIP": "Общее количество диалогов с сообщениями бота"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Количество ответов",
        "TOOLTIP": "Общее количество исходящих сообщений"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Количество ответов ИИ",
        "TOOLTIP": "Общее количество ответных сообщений, отправленных ботом"
      },
      "COPILOT_COUNT": {
        "LABEL": "Количество подготовленных ответов",
        "TOOLTIP": "Общее количество подсказок Copilot, подготовленных ботом для агентов"
      },
      "SUCCESS_RATE": {
        "LABEL": "Решено ИИ",
        "TOOLTIP": "Процент диалогов, решённых ИИ без передачи агенту"
      },
      "RESOLVE_TIME": {
        "LABEL": "Время решения",
        "TOOLTIP": "Медианное время от первого сообщения клиента до последнего сообщения бота/агента"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Количество диалогов",
        "TOOLTIP": "Общее количество диалогов, обработанных ботом"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Всего ответов",
        "TOOLTIP": "Общее количество ответов, отправленных ботом"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Скорость разрешения",
        "TOOLTIP": "Общее количество диалогов, разрешенных ботом / Общее количество диалогов, обработанных ботом * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Частота передач",
        "TOOLTIP": "Общее количество диалогов, передаваемых агентам / Общее количество диалогов, обрабатываемых ботом * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Не группировать",
      "INBOXES": "Источники",
      "LABELS": "Метки"
    },
    "GROUPED": {
      "CHART_TITLE": "Распределение по группам",
      "BACK_TO_ALL": "Показать все",
      "TABLE": {
        "INBOX": "Источник",
        "LABEL": "Метка",
        "CONVERSATIONS": "Диалоги",
        "MESSAGES": "Сообщения",
        "MESSAGES_TOOLTIP": "Общее количество исходящих сообщений",
        "AI_MESSAGES": "Ответы ИИ",
        "AI_MESSAGES_TOOLTIP": "Общее количество ответов ИИ, далее — количество положительных и отрицательных оценок конечных пользователей",
        "THUMBS_UP_TOOLTIP": "Количество ответов ИИ, оценённых конечными пользователями положительно (лайк)",
        "THUMBS_DOWN_TOOLTIP": "Количество ответов ИИ, оценённых конечными пользователями отрицательно (дизлайк)",
        "PREPARED": "Подготовленные ответы",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Доля сообщений этой группы от всех сообщений",
        "BOT_RESPONSES": "% ответов ИИ",
        "SUGGESTION_USED": "Использованные ответы",
        "SUGGESTION_USED_TOOLTIP": "Процент подготовленных ответов в этой группе, которые были использованы агентами",
        "SUGGESTION_NOT_USED": "Неиспользованные ответы",
        "SUGGESTION_NOT_USED_TOOLTIP": "Процент сообщений в этой группе, для которых был подготовлен ответ, но он не был использован"
      },
      "NOTES": {
        "TITLE": "Как рассчитываются показатели",
        "CONVERSATIONS": "Количество диалогов, в которых есть хотя бы одно исходящее сообщение за выбранный период.",
        "MESSAGES": "Общее количество исходящих (не приватных) сообщений, отправленных за выбранный период. Сюда входят как сообщения, сгенерированные ИИ, так и написанные людьми.",
        "PERCENTAGE": "Доля сообщений этой группы от всех исходящих сообщений по всем группам.",
        "AI_MESSAGES": "Количество исходящих сообщений, отправленных автоматически ботом ИИ (не считая подготовленных ответов для агентов). Числа в скобках показывают, сколько из этих ответов были оценены конечными пользователями положительно (лайк) и отрицательно (дизлайк).",
        "PREPARED": "Количество подсказок Copilot (подготовленных ответов), сгенерированных ботом ИИ для агентов за выбранный период. Это приватные сообщения, видимые только агентам, и они не учитываются как исходящие сообщения, поэтому это число может не совпадать со столбцом «Сообщения».",
        "SUGGESTION_USED": "Процент подготовленных ответов в этой группе, которые были использованы агентами. Это может не совпадать с количеством подготовленных ответов, так как сюда также могут входить подсказки, сгенерированные в предыдущие периоды.",
        "SUGGESTION_NOT_USED": "Процент исходящих сообщений в этой группе, для которых была доступна подсказка Copilot, но агент ответил, не используя её. Учитывается только тогда, когда агент действительно отправил ответ. Это может не совпадать с количеством подготовленных ответов, так как сюда также могут входить подсказки, сгенерированные в предыдущие периоды."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Обзор",
    "LIVE": "Онлайн",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Открытые диалоги",
      "LOADING_MESSAGE": "Загрузка метрик диалогов...",
      "OPEN": "Открытых",
      "UNATTENDED": "Неотвеченные",
      "UNASSIGNED": "Неназначен",
      "PENDING": "В ожидании"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Трафик сообщений",
      "NO_CONVERSATIONS": "Нет сообщений",
      "CONVERSATION": "{count} разговор",
      "CONVERSATIONS": "{count} разговоров",
      "DOWNLOAD_REPORT": "Скачать отчет"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Диалоги по операторам",
      "LOADING_MESSAGE": "Загрузка метрик оператора...",
      "NO_AGENTS": "Нет диалогов связанных с операторами",
      "TABLE_HEADER": {
        "AGENT": "Оператор",
        "OPEN": "Открыть",
        "UNATTENDED": "Неотвеченные",
        "STATUS": "Статус"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Команда",
        "OPEN": "Открыть",
        "UNATTENDED": "Неотвеченные",
        "STATUS": "Статус"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Статус операторов",
      "ONLINE": "В сети",
      "BUSY": "Занят",
      "OFFLINE": "Оффлайн"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Воскресенье",
    "MONDAY": "Понедельник",
    "TUESDAY": "Вторник",
    "WEDNESDAY": "Среда",
    "THURSDAY": "Четверг",
    "FRIDAY": "Пятница",
    "SATURDAY": "Суббота"
  },
  "SLA_REPORTS": {
    "HEADER": "Отчеты по SLA",
    "NO_RECORDS": "Разговоры с применением SLA недоступны.",
    "LOADING": "Загрузка данных по SLA...",
    "DOWNLOAD_SLA_REPORTS": "Скачать отчеты по SLA",
    "DOWNLOAD_FAILED": "Не удалось загрузить отчеты по SLA",
    "DROPDOWN": {
      "ADD_FIlTER": "Добавить фильтр",
      "CLEAR_ALL": "Очистить всё",
      "CLEAR_FILTER": "Очистить фильтр",
      "EMPTY_LIST": "Результаты не найдены",
      "NO_FILTER": "Нет доступных фильтров",
      "SEARCH": "Поиск по фильтру",
      "INPUT_PLACEHOLDER": {
        "SLA": "Название SLA",
        "AGENTS": "Имя оператора",
        "INBOXES": "Имя источника",
        "LABELS": "Название категории",
        "TEAMS": "Название команды"
      },
      "SLA": "Политика SLA",
      "INBOXES": "Входящие",
      "AGENTS": "Оператор",
      "LABELS": "Метка",
      "TEAMS": "Команда"
    },
    "WITH": "с",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Уровень выполнения",
        "TOOLTIP": "Процент успешно выполненных SLA из общего числа созданных"
      },
      "NO_OF_MISSES": {
        "LABEL": "Количество пропущенных SLA",
        "TOOLTIP": "Общее количество пропущенных SLA за определенный период"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Количество диалогов",
        "TOOLTIP": "Общее количество диалогов с SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Политика",
        "CONVERSATION": "Диалоги",
        "AGENT": "Оператор"
      },
      "VIEW_DETAILS": "Просмотреть подробности"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Промежуточный итог",
    "NO_TEAM": "Без команды",
    "GROUP_BY_TEAMS": "Группировать по командам",
    "INBOX": "Электронная почта",
    "AGENT": "Оператор",
    "TEAM": "Команда",
    "LABEL": "Метка",
    "TOTAL": "Всего",
    "AVG_RESOLUTION_TIME": "Среднее время решения",
    "AVG_FIRST_RESPONSE_TIME": "Среднее время первого ответа",
    "AVG_REPLY_TIME": "Среднее время ожидания клиента",
    "RESOLUTION_COUNT": "Количество завершенных",
    "CONVERSATIONS": "Количество диалогов",
    "OUTGOING_CHATS": "Исходящие чаты",
    "OUTGOING_EMAILS": "Исходящие письма",
    "PHONE_CALLS": "Телефонные звонки",
    "INBOUND_CALLS": "Входящие звонки",
    "OUTBOUND_CALLS": "Исходящие звонки",
    "TOTAL_ACTIVITIES": "Всего действий",
    "ONLINE_TIME": "Время онлайн",
    "QUEUE_AVAILABLE_TIME": "Время доступности в очереди",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Количество исходящих сообщений, отправленных этим агентом",
      "OUTGOING_EMAILS": "Количество исходящих писем, отправленных этим агентом",
      "PHONE_CALLS": "Общее количество телефонных звонков, назначенных этому агенту (сумма входящих и исходящих звонков)",
      "TOTAL_ACTIVITIES": "Общее количество действий: входящие звонки + исходящие звонки + исходящие чаты + исходящие письма",
      "INBOUND_CALLS": "Количество входящих звонков, назначенных этому агенту",
      "OUTBOUND_CALLS": "Количество исходящих звонков, назначенных этому агенту",
      "AVG_FIRST_RESPONSE_TIME": "Среднее время от создания диалога до первого ответа агента в диалогах, назначенных этому агенту",
      "AVG_RESOLUTION_TIME": "Среднее время от создания диалога до решения в диалогах, назначенных этому агенту",
      "AVG_REPLY_TIME": "Среднее время ожидания клиентов между их сообщением и ответом агента в диалогах, назначенных этому агенту",
      "ONLINE_TIME": "Общее время, в течение которого агент был онлайн или занят за выбранный период",
      "QUEUE_AVAILABLE_TIME": "Общее время, в течение которого агент был доступен в телефонных очередях за выбранный период"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Отчёты по звонкам",
    "DESCRIPTION": "Отслеживайте показатели телефонных звонков с подробной аналитикой по входящим и исходящим звонкам, сгруппированной по агенту или источнику для всестороннего анализа.",
    "DOWNLOAD_PHONE_REPORTS": "Скачать отчёт по звонкам",
    "GROUP_BY": {
      "LABEL": "Группировать по",
      "AGENT": "Агент",
      "INBOX": "Источник"
    },
    "TABLE": {
      "TOTAL_CALLS": "Всего",
      "INBOUND_CALLS": "Входящие",
      "OUTBOUND_CALLS": "Исходящие",
      "FAILED_OUTBOUND_CALLS": "Неудавшиеся исходящие",
      "AVG_AGENT_HANDLED_DURATION": "Средняя длительность",
      "TOTAL_AGENT_HANDLED_DURATION": "Общая длительность",
      "AVG_RINGING_TIME": "Среднее время дозвона",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Успешность %",
      "UNIQUE_CALLERS": "Уникальные звонящие",
      "UNIQUE_CALLED_CONTACTS": "Уникальные вызванные",
      "UNANSWERED_MISSED_CALLS": "Пропущенные без обратного звонка",
      "UNANSWERED_MISSED_PERCENTAGE": "% пропущенных без обратного звонка",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Пропущенные без обратного звонка, с недостаточным количеством попыток",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "% пропущенных без обратного звонка, с недостаточным количеством попыток"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Общее количество всех звонков (включая несоединённые)",
      "INBOUND_CALLS": "Количество соединённых звонков",
      "OUTBOUND_CALLS": "Общее количество всех исходящих звонков (включая несоединённые)",
      "FAILED_OUTBOUND_CALLS": "Количество исходящих звонков, которые не удалось соединить",
      "AVG_AGENT_HANDLED_DURATION": "Средняя длительность звонков, обработанных агентами",
      "TOTAL_AGENT_HANDLED_DURATION": "Общая длительность всех звонков, обработанных агентами",
      "AVG_RINGING_TIME": "Среднее время, в течение которого звонок звонил до ответа",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Процент исходящих звонков, успешно соединённых",
      "UNIQUE_CALLERS": "Количество уникальных контактов, совершивших входящие звонки",
      "UNIQUE_CALLED_CONTACTS": "Количество уникальных контактов, которым звонили исходящими звонками",
      "UNANSWERED_MISSED_CALLS": "Количество пропущенных звонков без успешного обратного звонка (звонок соединён). Может включать звонки, которые ещё можно обработать в течение рабочего дня",
      "UNANSWERED_MISSED_PERCENTAGE": "Процент уникальных звонящих, чьи звонки были пропущены без обратного звонка (пропущенные без обратного звонка / уникальные звонящие)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Количество пропущенных звонков с менее чем 2 попытками обратного звонка. Может включать звонки, которые ещё можно обработать в течение рабочего дня",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Процент уникальных звонящих с менее чем 2 попытками обратного звонка ((пропущенные без обратного звонка − достаточно обработанные) / уникальные звонящие)"
    }
  }
}
